module.exports = "textarea {\n  resize: none;\n  width: 100%;\n  height: 150px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/breakdowns/breakdowns-close/breakdowns-close.component.css
// module id = ./src/app/breakdowns/breakdowns-close/breakdowns-close.component.css
// module chunks = main